import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ number, label, dark = false }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`chapter-${number}`}>
    <span className={`font-display text-sm font-bold tracking-[0.25em] ${dark ? "text-volt" : "text-voltdark"}`}>
      {number}
    </span>
    <span className={`h-px w-12 ${dark ? "bg-white/25" : "bg-black/15"}`} />
    <span className={`text-xs font-bold tracking-[0.25em] uppercase ${dark ? "text-white/50" : "text-black/50"}`}>
      {label}
    </span>
  </div>
);
